// Elapsed time is derived from the server's `started_at`, so it is a whole number of seconds
// and never negative. `H:MM:SS` keeps even a 12-hour session readable without a unit suffix.
export const formatElapsedDuration = (totalSeconds: number): string => {
    const safeSeconds = Number.isFinite(totalSeconds) && totalSeconds > 0 ? Math.floor(totalSeconds) : 0;

    const hours = Math.floor(safeSeconds / 3600);
    const minutes = Math.floor((safeSeconds % 3600) / 60);
    const seconds = safeSeconds % 60;

    return `${hours}:${`${minutes}`.padStart(2, '0')}:${`${seconds}`.padStart(2, '0')}`;
};

// Logged totals arrive already rounded to whole minutes by the server, matching the minutes
// the work report carries, so this only formats and never re-rounds.
export const formatLoggedMinutes = (totalMinutes: number): string => {
    const safeMinutes = Number.isFinite(totalMinutes) && totalMinutes > 0 ? Math.floor(totalMinutes) : 0;

    const hours = Math.floor(safeMinutes / 60);
    const minutes = safeMinutes % 60;

    return `${hours}h ${`${minutes}`.padStart(2, '0')}min`;
};
